import {Box, Paper, styled, Typography} from '@mui/material'

export const StyledChatBoxContainer = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.common.black,
  padding: '15px',
  height: '100%',
  marginTop: '15px',
  borderRadius: '4px',
  position: 'absolute',
  maxHeight: '460px',
  width: '97%'
}))

export const StyledDivContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'mainPrompt'
})(({mainPrompt}) => ({
  minHeight: mainPrompt ? '300px' : '380px',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  maxHeight: 'calc(100% - 130px)',
  paddingRight: '10px'
}))

export const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.heading.fontSize.xl,
  marginTop: '6px',
  marginBottom: '6px'
}))

export const StyledSpan = styled('span')(({theme}) => ({
  color: theme.palette.primary.main
}))

export const StyledPaper = styled(Paper)(({theme}) => ({
  backgroundColor: theme.palette.common.white
}))

export const StyledTitleTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'customFontWeight' && prop !== 'customFontSize'
})(({theme, customFontWeight, customFontSize}) => ({
  fontSize: customFontSize,
  fontWeight: customFontWeight,
  color: theme.palette.common.black,
  padding: '10px'
}))

export const StyledManualBoxContainer = styled(Box)(({theme}) => ({
  marginTop: '15px',
  borderRadius: '4px'
}))

export const StyledManualPaperContainer = styled(Paper)(({theme}) => ({
  backgroundColor: theme.palette.common.black,
  padding: '15px',
  height: '100%'
}))
